import React, { useEffect, useState } from "react";
import { FunctionComponent } from "react";
import { Layout, Row, Col, Space, Spin, Form } from "antd";
import { SearchPatientForm } from "./SearchPatient/SearchPatientForm";
import "./StaffHome.css";
import { SearchPatientStepper } from "./SearchPatient/SearchPatientStepper";
import { SearchPatientSwitch } from "./SearchPatient/SearchPatientSwitch";
import {
  AMERICA_TZ,
  ASIA_TZ,
  CONSULTING,
  DAY,
  EVENING,
  HAS_APPOINTMENT,
} from "../CONSTANTS";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { checkIfStringIsEmpty } from "../utils";
import { AddPatientToAppointment } from "./SearchPatient/AddPatientToAppointment/AddPatientToAppointment";
import {
  convertAppointmentSlotsToStrings,
  getAppointmentSlotsAndSetTimes,
  getNextAvailableTime,
} from "./utils";
import { ConsultingSlotsType } from "./types";
import background from "../../bg-image-4.jpg";
const { Content } = Layout;

dayjs.extend(utc);
dayjs.extend(timezone);

export function StaffHome(): JSX.Element {
  const now = dayjs();
  const nowWithTZ = now.tz(AMERICA_TZ);
  const setTime = now.tz(AMERICA_TZ).hour(16).minute(0);
  const [form] = Form.useForm();
  const [current, setCurrent] = useState(2);
  const [availableSlots, setAvailableAppointmentSlots] = useState<
    ConsultingSlotsType[]
  >([]);
  const [readableAppointmentTimes, setReadableAppointmentTimes] = useState<
    string[]
  >([]);

  const [patientDetails, setPatientDetails] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    appointmentStatus: HAS_APPOINTMENT,
    consultingSlot: EVENING,
    appointmentTimes: "",
  });
  const [consultingSlot, setConsultingSlot] = useState<string>(EVENING);

  useEffect(() => {
    getAppointmentSlotsAndSetTimes(
      consultingSlot,
      setAvailableAppointmentSlots,
      setReadableAppointmentTimes
    );
  }, [consultingSlot]);

  useEffect(() => {
    if (
      readableAppointmentTimes !== undefined &&
      readableAppointmentTimes.length > 0
    ) {
      setPatientDetails({
        firstName: "",
        lastName: "",
        phoneNumber: "",

        appointmentStatus: HAS_APPOINTMENT,
        consultingSlot: consultingSlot,
        appointmentTimes: readableAppointmentTimes[0],
      });
      form.setFieldValue("appointmentTimes", readableAppointmentTimes[0]);
    }
  }, [readableAppointmentTimes]);
  return (
    <Content
      style={{
        backgroundImage: `url(
        ${background}
        )`,
      }}
      className="bg-fixed"
    >
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex" }}
        className="staff-home-space"
      >
        <Row>
          <Col span={24} className="pt-12">
            {/* <SearchPatientStepper current={current}> */}
            {checkIfStringIsEmpty(patientDetails.appointmentTimes) ? (
              <Spin />
            ) : (
              <div className="relative ">
                <AddPatientToAppointment
                  patientDetails={patientDetails}
                  current={current}
                  setCurrent={setCurrent}
                  setPatientDetails={setPatientDetails}
                  availableSlots={availableSlots}
                  readableAppointmentTimes={readableAppointmentTimes}
                  setConsultingSlot={setConsultingSlot}
                  consultingSlot={consultingSlot}
                  setAvailableAppointmentSlots={setAvailableAppointmentSlots}
                  setReadableAppointmentTimes={setReadableAppointmentTimes}
                  form={form}
                />
              </div>
            )}
          </Col>
        </Row>
        <Row></Row>
      </Space>
    </Content>
  );
}
